<div class="card-base">
  <div class="card-content-operation">
      <div class="card-container mat-elevation-z1">
          <div class="card-content">
              <form *ngIf="laoded" [formGroup]="form">
                  <app-medical-order-operation-control-component formControlName="MedicalOrderOperation">
                  </app-medical-order-operation-control-component>
              </form>
          </div>

      </div>
  </div>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button *ngIf="!loading" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
  </div>
</div>
